import { injectable } from 'inversify';

import { IScheduleRepository } from '@/domain/repositories/schedule.repository.interface';
import { Result } from '@/entities/Result';
import { ScheduleResults } from '@/entities/ScheduleMatch';
import { getScheduleMatchup } from '@/infrastructure/network/data';

@injectable()
export class ScheduleRepository implements IScheduleRepository {
	async getScheduleMacthups(
		startDate: string,
		endDate: string,
		searchTerm: string,
		statusValue: string,
		tzOffset: string,
		teamLeagueUuid: string,
		scheduleGroupUuid?: string,
		poolUuid?: string,
		seasonUuid?: string,
		organizationUuid?: string,
		urlTeam?: string,
		shouldListCurrentMatchups?: boolean,
		excludeCurrentAndUpcoming?: boolean
	): Promise<Result<ScheduleResults>> {
		const result = await getScheduleMatchup({
			startDate,
			endDate,
			searchTerm,
			statusValue,
			tzOffset,
			scheduleGroupUuid,
			poolUuid,
			seasonUuid,
			organizationUuid,
			teamLeagueUuid,
			urlTeam,
			shouldListCurrentMatchups,
			excludeCurrentAndUpcoming
		});

		if (result.statusCode === 200) {
			const scheduleMatchups = result.data;
			return {
				data: scheduleMatchups,
				statusCode: result.statusCode
			};
		} else {
			return {
				statusCode: result.statusCode,
				correlationId: result.correlationId,
				error: result.error
			};
		}
	}
}
